angular.module('common')
    .service('localStorageService', [function () {
        function LocalStorageService() {
        };

        LocalStorageService.prototype.storeUserData = function (response, userName, isAdmin, isTechSuper, credsKey) {
            var authentication = {
                username: userName,
                isAdmin: isAdmin,
                steps: !(isAdmin || isTechSuper),
                isTechSuper: isTechSuper
            };

            var authenticationRefresh = {
                credsKey: credsKey,
                expires_in: response.expires_in,
                timestamp: (new Date()).toISOString()
            };

            var authorizationData = JSON.stringify({ token: response.access_token, username: userName });
            var authenticationData = JSON.stringify(authentication);
            var authenticationRefreshData = JSON.stringify(authenticationRefresh);

            localStorage.setItem("authorizationData", authorizationData);
            localStorage.setItem("authenticationData", authenticationData);
            localStorage.setItem("authenticationRefreshData", authenticationRefreshData);
        };

        return new LocalStorageService();
    }]);